import { useEffect, useRef } from "react";
import { useSearch } from "../../../../contexts/SearchContext";
import { useSelectedResult } from "../../../../contexts/SelectedResultContext";
import { useBookingFlow } from "./useBookingFlow";
import { buildSelectedResultForLdsFlightBooking } from "../../adapters/buildSelectedResultForLdsFlightBooking.js";

/**
 * מסנכרן deal נבחר (מתוצאות חיפוש / rawDeal במוקאפ) ל-selectedResult + roomsAndPaxInfo,
 * כדי ש-calculateLdsTotalPayment ב-SelectedResultContext יופעל אוטומטית (אותו useEffect כמו בחבילות).
 */
export function useFlightBookingMockupLdsSync() {
  const {
    savedDeal,
    roomInfo,
    getLdsDealRoomFareRows,
    calculateLDSDealFareForRoomsComposition,
  } = useSearch();
  const { setSelectedResult, setRoomsAndPaxInfo, initLdsSupplements } =
    useSelectedResult();
  const { selectedFlightOffer } = useBookingFlow();

  const rawDeal =
    selectedFlightOffer?.rawDeal != null
      ? selectedFlightOffer.rawDeal
      : savedDeal;
  const dealKey = rawDeal?.dealId ?? rawDeal?.ID ?? null;
  const roomsKey = JSON.stringify(roomInfo?.rooms ?? []);

  const savedRef = useRef(savedDeal);
  const offerRef = useRef(selectedFlightOffer);
  savedRef.current = savedDeal;
  offerRef.current = selectedFlightOffer;

  const getRowsRef = useRef(getLdsDealRoomFareRows);
  const calcRef = useRef(calculateLDSDealFareForRoomsComposition);
  const setSelRef = useRef(setSelectedResult);
  const setRoomsRef = useRef(setRoomsAndPaxInfo);
  const initSuppRef = useRef(initLdsSupplements);
  getRowsRef.current = getLdsDealRoomFareRows;
  calcRef.current = calculateLDSDealFareForRoomsComposition;
  setSelRef.current = setSelectedResult;
  setRoomsRef.current = setRoomsAndPaxInfo;
  initSuppRef.current = initLdsSupplements;

  useEffect(() => {
    const raw =
      offerRef.current?.rawDeal != null
        ? offerRef.current.rawDeal
        : savedRef.current;
    const key = raw?.dealId ?? raw?.ID ?? null;

    if (!key || !raw) {
      console.log(
        "[FlightBookingMockup] lds sync skip: no deal (awaiting flight selection or search)"
      );
      return;
    }

    console.log(
      "[FlightBookingMockup] before buildSelectedResultForLdsFlightBooking",
      { dealKey: key, roomsKeyLen: roomsKey.length }
    );

    const built = buildSelectedResultForLdsFlightBooking({
      savedDeal: raw,
      roomInfo,
      linkedFlightsOverride: undefined,
      shortenedDeal: null,
      getLdsDealRoomFareRows: getRowsRef.current,
      calculateLDSDealFareForRoomsComposition: calcRef.current,
    });

    if (!built.ok) {
      console.warn(
        "[FlightBookingMockup] buildSelectedResultForLdsFlightBooking failed",
        built
      );
      return;
    }

    console.log(
      "[FlightBookingMockup] after buildSelectedResultForLdsFlightBooking",
      {
        dealId: built.selectedResult.dealId,
        roomsAndPaxRows: built.roomsAndPaxInfo.length,
      }
    );
    console.log("RAW LDS DEAL", raw.dealFare, raw.fareDetails);
    console.log("RAW LDS supplements", raw?.supplement);

    setSelRef.current(built.selectedResult);
    setRoomsRef.current(built.roomsAndPaxInfo, false);
    initSuppRef.current(built.selectedResult, undefined, built.roomsAndPaxInfo);

    console.log(
      "[FlightBookingMockup] state updated: selectedResult + roomsAndPaxInfo + initLdsSupplements"
    );
    console.log(
      "[FlightBookingMockup] before calculateLdsTotalPayment: יופעל מ-SelectedResultContext כשיש roomsAndPaxInfo עם room.ourFareDetails.ourTotalFare"
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dealKey/roomsKey בלבד; פונקציות מ-SearchContext לא יציבות
  }, [dealKey, roomsKey]);
}
